var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteSideMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.935,
    height: 29,
    viewBox: "0 0 29.935 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "white_side_menu_icon",
    transform: "translate(-3208 -709.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "menu_FILL0_wght600_GRAD0_opsz48",
    d: "M7.118,31.912A1.589,1.589,0,0,1,5.5,30.294a1.5,1.5,0,0,1,.465-1.133,1.6,1.6,0,0,1,1.153-.445H19.472a1.566,1.566,0,0,1,1.153.465,1.518,1.518,0,0,1,.465,1.112,1.589,1.589,0,0,1-1.618,1.618Zm0-8.738a1.618,1.618,0,1,1,0-3.236h26.7a1.618,1.618,0,1,1,0,3.236Zm0-8.778a1.566,1.566,0,0,1-1.153-.465A1.518,1.518,0,0,1,5.5,12.818,1.589,1.589,0,0,1,7.118,11.2H27.177a1.589,1.589,0,0,1,1.618,1.618,1.5,1.5,0,0,1-.465,1.133,1.6,1.6,0,0,1-1.153.445Z",
    transform: "translate(3202.5 702.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 29,
    height: 29,
    transform: "translate(3208.468 709.658)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSideMenuIcon);
export default __webpack_public_path__ + "static/media/white_side_menu_icon.e5787e7faf9bdcd080e6a454550b98d2.svg";
export { ForwardRef as ReactComponent };